import React from "react";
import { withErrorBoundary } from "@/utils/routeUtils";
import Home from "@/pages/Home";
import Index from "@/pages/Index";
import Technology from "@/pages/Technology";
import Resources from "@/pages/Resources";
import SubscriptionPage from "@/pages/Subscription";
import SubscriptionForm from "@/pages/SubscriptionForm";
import About from "@/pages/About";
import AssessmentEfficiency from "@/pages/impact/AssessmentEfficiency";
import EHRWorkflowIntegrations from "@/pages/platform-devices/EHRWorkflowIntegrations";
import AIEnabledBedsideDevices from "@/pages/platform-devices/AIEnabledBedsideDevices";
import Wearables from "@/pages/platform-devices/Wearables";
import EarlyDetection from "@/pages/impact/EarlyDetection";
import PatientSatisfaction from "@/pages/impact/PatientSatisfaction";
import { lazy } from "react";
import Account from "@/pages/Account";
import Settings from "@/pages/Settings";

// New B2B2C pages
import Solutions from "@/pages/Solutions";
import PlatformDevices from "@/pages/PlatformDevices";
import ComplianceSecurity from "@/pages/ComplianceSecurity";
import ContactRequestDemo from "@/pages/ContactRequestDemo";
import ClinicalAutomation from "@/pages/solutions/ClinicalAutomation";
import WorkforceCustomerExperience from "@/pages/solutions/WorkforceCustomerExperience";
import VirtualNursingObservation from "@/pages/solutions/VirtualNursingObservation";
import CognitiveScreeningIntake from "@/pages/solutions/CognitiveScreeningIntake";
import RemotePatientMonitoring from "@/pages/solutions/RemotePatientMonitoring";
import PatientAccessAutomation from "@/pages/solutions/PatientAccessAutomation";
import WorkforceOptimization from "@/pages/solutions/WorkforceOptimization";
import CaseStudies from "@/pages/resources/CaseStudies";
import WhitePapersResearch from "@/pages/resources/WhitePapersResearch";
import WebinarsDemos from "@/pages/resources/WebinarsDemos";
import BlogNews from "@/pages/resources/BlogNews";

const LearnMore = lazy(() => import("@/pages/LearnMore"));
const HowItWorks = lazy(() => import("@/pages/HowItWorks"));

// Main routes - these take precedence over other route groups
export const mainRoutes = [
  {
    path: "/",
    element: withErrorBoundary(<Index />),
    priority: 1, // Higher priority routes
  },
  {
    path: "/home",
    element: withErrorBoundary(<Home />),
    priority: 1,
  }
];

// Secondary routes - these will be merged with lower priority
export const secondaryRoutes = [
  // New B2B2C routes
  {
    path: "/solutions",
    element: withErrorBoundary(<Solutions />),
  },
  {
    path: "/solutions/clinical-automation",
    element: withErrorBoundary(<ClinicalAutomation />),
  },
  {
    path: "/solutions/workforce-customer-experience",
    element: withErrorBoundary(<WorkforceCustomerExperience />),
  },
  {
    path: "/solutions/clinical-automation/virtual-nursing-observation",
    element: withErrorBoundary(<VirtualNursingObservation />),
  },
  {
    path: "/solutions/clinical-automation/cognitive-screening-intake",
    element: withErrorBoundary(<CognitiveScreeningIntake />),
  },
  {
    path: "/solutions/clinical-automation/remote-patient-monitoring",
    element: withErrorBoundary(<RemotePatientMonitoring />),
  },
  {
    path: "/solutions/clinical-automation/patient-access-automation",
    element: withErrorBoundary(<PatientAccessAutomation />),
  },
  {
    path: "/solutions/workforce-customer-experience/workforce-optimization",
    element: withErrorBoundary(<WorkforceOptimization />),
  },
  {
    path: "/platform-devices/ai-enabled-bedside-devices",
    element: withErrorBoundary(<AIEnabledBedsideDevices />),
  },
  {
    path: "/platform-devices/wearables",
    element: withErrorBoundary(<Wearables />),
  },
  {
    path: "/platform-devices/ehr-workflow-integrations",
    element: withErrorBoundary(<EHRWorkflowIntegrations />),
  },
  {
    path: "/platform-devices",
    element: withErrorBoundary(<PlatformDevices />),
  },
  {
    path: "/compliance-security",
    element: withErrorBoundary(<ComplianceSecurity />),
  },
  {
    path: "/contact-request-demo",
    element: withErrorBoundary(<ContactRequestDemo />),
  },
  // Existing routes
  {
    path: "/technology",
    element: withErrorBoundary(<Technology />),
  },
  {
    path: "/resources",
    element: withErrorBoundary(<Resources />),
  },
  {
    path: "/resources/case-studies",
    element: withErrorBoundary(<CaseStudies />),
  },
  {
    path: "/resources/white-papers-research",
    element: withErrorBoundary(<WhitePapersResearch />),
  },
  {
    path: "/resources/webinars-demos",
    element: withErrorBoundary(<WebinarsDemos />),
  },
  {
    path: "/resources/blog-news",
    element: withErrorBoundary(<BlogNews />),
  },
  {
    path: "/about",
    element: withErrorBoundary(<About />),
  },
  {
    path: "/subscription",
    element: withErrorBoundary(<SubscriptionPage />),
  },
  {
    path: "/subscription-form",
    element: withErrorBoundary(<SubscriptionForm />),
  },
  {
    path: "/learn-more",
    element: withErrorBoundary(<LearnMore />),
  },
  {
    path: "/how-it-works",
    element: withErrorBoundary(<HowItWorks />),
  },
  {
    path: "/impact/assessment-efficiency",
    element: withErrorBoundary(<AssessmentEfficiency />),
  },
  {
    path: "/impact/early-detection",
    element: withErrorBoundary(<EarlyDetection />),
  },
  {
    path: "/impact/patient-satisfaction",
    element: withErrorBoundary(<PatientSatisfaction />),
  },
  {
    path: "/account",
    element: withErrorBoundary(<Account />),
  },
  {
    path: "/settings",
    element: withErrorBoundary(<Settings />),
  }
];
